import React, { useEffect, useMemo, useState } from 'react';
import { BOAPI } from "../service/UsersService";

// אותו מיפוי בדיוק כמו MonthToNum בקליינט (react-app/functions/LetterToNum.js) —
// תשרי=1 ... אלול=12. קבוע, לא תאריך לועזי, כי ימים מיוחדים חוזרים על אותו
// יום/חודש עברי כל שנה (ראו CREATE TABLE [specialDays] ב-Tables.sql).
const HEB_MONTHS = [
  { value: 1, label: 'תשרי' },
  { value: 2, label: 'חשון' },
  { value: 3, label: 'כסלו' },
  { value: 4, label: 'טבת' },
  { value: 5, label: 'שבט' },
  { value: 6, label: 'אדר' },
  { value: 7, label: 'ניסן' },
  { value: 8, label: 'אייר' },
  { value: 9, label: 'סיוון' },
  { value: 10, label: 'תמוז' },
  { value: 11, label: 'אב' },
  { value: 12, label: 'אלול' },
];

const monthLabel = (v) => HEB_MONTHS.find((m) => m.value === Number(v))?.label || v;

const defaultNewDay = () => ({
  title: '',
  hebMonth: 1,
  hebDay: 1,
  leadDays: 0,
  imageUrl: '',
  aboutText: '',
  biographyText: '',
});

const validateDay = (data) => {
  if (!data.title?.trim()) return 'נא להזין כותרת';
  if (!data.hebDay || data.hebDay < 1 || data.hebDay > 30) return 'יום בחודש לא תקין (1-30)';
  if (data.leadDays === '' || data.leadDays < 0) return 'מספר ימי הקדמה לא תקין';
  return null;
};

// שדות הטופס המשותפים בין הוספה לעריכה.
const SpecialDayFields = ({ data, onChange }) => (
  <>
    <div style={s.formRow}>
      <div style={s.formGroup}>
        <label style={s.label}>כותרת *</label>
        <input
          type="text"
          value={data.title}
          onChange={(e) => onChange('title', e.target.value)}
          style={s.input}
          maxLength={64}
          placeholder='למשל: כ׳ אב - הילולת ר׳ לוי יצחק שניאורסון'
        />
      </div>
    </div>
    <div style={s.formRow}>
      <div style={s.formGroup}>
        <label style={s.label}>חודש עברי *</label>
        <select value={data.hebMonth} onChange={(e) => onChange('hebMonth', Number(e.target.value))} style={s.input}>
          {HEB_MONTHS.map((m) => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>
      </div>
      <div style={s.formGroup}>
        <label style={s.label}>יום בחודש (1-30) *</label>
        <input
          type="number"
          min={1}
          max={30}
          value={data.hebDay}
          onChange={(e) => onChange('hebDay', Number(e.target.value))}
          style={s.input}
        />
      </div>
      <div style={s.formGroup}>
        <label style={s.label}>ימי הקדמה להצגת האייקון</label>
        <input
          type="number"
          min={0}
          value={data.leadDays}
          onChange={(e) => onChange('leadDays', Number(e.target.value))}
          style={s.input}
          placeholder="0 = רק ביום עצמו"
        />
      </div>
    </div>
    <div style={s.formGroup}>
      <label style={s.label}>קישור לתמונה (אופציונלי)</label>
      <input
        type="text"
        value={data.imageUrl}
        onChange={(e) => onChange('imageUrl', e.target.value)}
        style={s.input}
        placeholder="https://..."
      />
    </div>
    <div style={s.formGroup}>
      <label style={s.label}>אודות</label>
      <textarea
        value={data.aboutText}
        onChange={(e) => onChange('aboutText', e.target.value)}
        style={s.textarea}
        rows={3}
      />
    </div>
    <div style={s.formGroup}>
      <label style={s.label}>ביוגרפיה</label>
      <textarea
        value={data.biographyText}
        onChange={(e) => onChange('biographyText', e.target.value)}
        style={s.textarea}
        rows={5}
      />
    </div>
  </>
);

const defaultLinkForm = () => ({ title: '', url: '', categoryId: '', newCategoryName: '' });

// שדות משותפים לטופס "שיוך מקישור חיצוני" ולטופס "עריכת שיעור" — כותרת,
// קישור, ובחירת רב קיים או הזנת רב חדש.
const LessonLinkFields = ({ data, onChange, categories }) => (
  <>
    <div style={s.formRow}>
      <div style={s.formGroup}>
        <label style={s.label}>כותרת השיעור *</label>
        <input
          type="text"
          value={data.title}
          onChange={(e) => onChange('title', e.target.value)}
          style={s.input}
          placeholder="שם השיעור"
        />
      </div>
    </div>
    <div style={s.formGroup}>
      <label style={s.label}>קישור לקובץ השמע *</label>
      <input
        type="text"
        value={data.url}
        onChange={(e) => onChange('url', e.target.value)}
        style={s.input}
        placeholder="https://..."
      />
    </div>
    <div style={s.formRow}>
      <div style={s.formGroup}>
        <label style={s.label}>רב קיים</label>
        <select
          value={data.categoryId}
          onChange={(e) => { onChange('categoryId', e.target.value); onChange('newCategoryName', ''); }}
          style={s.input}
        >
          <option value="">בחר רב קיים...</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>
      <div style={s.formGroup}>
        <label style={s.label}>או רב חדש</label>
        <input
          type="text"
          value={data.newCategoryName}
          onChange={(e) => { onChange('newCategoryName', e.target.value); onChange('categoryId', ''); }}
          style={s.input}
          placeholder="שם רב שעדיין לא קיים ברשימה"
        />
      </div>
    </div>
  </>
);

// ניהול "שיעורים מתורתו" של יום מיוחד ספציפי — חיפוש+שיוך שיעורי שמע קיימים
// (כרשימת שורות לחיצות, לא dropdown — נגישה יותר), ובנוסף אפשרות לשייך שיעור
// מקישור חיצוני (יוצר שורה חדשה ב-mp3FilesPlayer, ומאפשר גם ליצור רב חדש
// אם הרב המבוקש עדיין לא קיים ברשימת הקטגוריות).
const LessonsManager = ({ specialDayId }) => {
  const [lessons, setLessons] = useState([]);
  const [files, setFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [query, setQuery] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [error, setError] = useState(null);

  const [showLinkForm, setShowLinkForm] = useState(false);
  const [linkForm, setLinkForm] = useState(defaultLinkForm());

  // עריכת שיעור קיים (משנה את שורת mp3FilesPlayer עצמה — כותרת/קישור/רב).
  const [editingLessonId, setEditingLessonId] = useState(null);
  const [editForm, setEditForm] = useState(defaultLinkForm());

  useEffect(() => { loadLessons(); loadCategories(); }, []);

  const loadLessons = async () => {
    const resp = await BOAPI.fetchSpecialDayLessons(specialDayId);
    if (Array.isArray(resp)) {
      const [statusObj, data] = resp;
      if (statusObj[0]?.code === 0 && Array.isArray(data)) setLessons(data);
    }
  };

  const loadCategories = async () => {
    const resp = await BOAPI.fetchMp3Categories();
    if (Array.isArray(resp)) {
      const [statusObj, data] = resp;
      if (statusObj[0]?.code === 0 && Array.isArray(data)) setCategories(data);
    }
  };

  useEffect(() => {
    const t = setTimeout(async () => {
      const resp = await BOAPI.searchMp3Files(query.trim() || undefined, categoryId || undefined);
      if (Array.isArray(resp)) {
        const [statusObj, data] = resp;
        if (statusObj[0]?.code === 0 && Array.isArray(data)) setFiles(data);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [query, categoryId]);

  const assignedMp3Ids = new Set(lessons.map((l) => l.mp3Id));

  const handleAdd = async (mp3Id) => {
    try {
      const resp = await BOAPI.addSpecialDayLesson({ specialDayId, mp3Id, sortOrder: lessons.length });
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) {
          setError(null);
          await loadLessons();
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בשיוך');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בשיוך');
    }
  };

  const handleRemove = async (row) => {
    if (!window.confirm(`להסיר את השיעור "${row.mp3Title}"?`)) return;
    try {
      const resp = await BOAPI.deleteSpecialDayLesson(row.id);
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) await loadLessons();
        else setError(statusObj[0]?.msg || 'שגיאה בהסרה');
      }
    } catch (err) {
      setError(err.message || 'שגיאה בהסרה');
    }
  };

  const openEdit = (row) => {
    setEditingLessonId(row.id);
    setEditForm({
      title: row.mp3Title || '',
      url: row.mp3Url || '',
      categoryId: row.mp3CategoryId ? String(row.mp3CategoryId) : '',
      newCategoryName: '',
    });
    setError(null);
  };

  const handleSaveEdit = async (row) => {
    if (!editForm.title.trim() || !editForm.url.trim()) { setError('נא להזין כותרת וקישור'); return; }
    if (!editForm.categoryId && !editForm.newCategoryName.trim()) { setError('נא לבחור רב קיים או להזין שם רב חדש'); return; }
    try {
      const resp = await BOAPI.updateMp3File({
        mp3Id: row.mp3Id,
        title: editForm.title.trim(),
        url: editForm.url.trim(),
        categoryId: editForm.categoryId ? Number(editForm.categoryId) : undefined,
        newCategoryName: editForm.categoryId ? undefined : editForm.newCategoryName.trim(),
      });
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) {
          setError(null);
          setEditingLessonId(null);
          await Promise.all([loadLessons(), loadCategories()]);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בעדכון');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בעדכון');
    }
  };

  const handleAddFromLink = async () => {
    if (!linkForm.title.trim() || !linkForm.url.trim()) { setError('נא להזין כותרת וקישור'); return; }
    if (!linkForm.categoryId && !linkForm.newCategoryName.trim()) { setError('נא לבחור רב קיים או להזין שם רב חדש'); return; }
    try {
      const resp = await BOAPI.addSpecialDayLessonFromLink({
        specialDayId,
        title: linkForm.title.trim(),
        url: linkForm.url.trim(),
        categoryId: linkForm.categoryId ? Number(linkForm.categoryId) : undefined,
        newCategoryName: linkForm.categoryId ? undefined : linkForm.newCategoryName.trim(),
      });
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) {
          setError(null);
          setShowLinkForm(false);
          setLinkForm(defaultLinkForm());
          await Promise.all([loadLessons(), loadCategories()]);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בהוספה');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בהוספה');
    }
  };

  return (
    <div style={s.lessonsSection}>
      <div style={s.targetTitle}>שיעורים מתורתו</div>
      {error && <div style={s.error}>❌ {error}</div>}

      {lessons.length === 0 ? (
        <div style={s.noAssignments}>עדיין לא שויכו שיעורים</div>
      ) : (
        <div style={s.chipsRow}>
          {lessons.map((row) => (
            <React.Fragment key={row.id}>
              <div style={s.chip}>
                <span style={s.chipLabel}>{row.mp3Title}{row.categoryName ? ` (${row.categoryName})` : ''}</span>
                <button onClick={() => (editingLessonId === row.id ? setEditingLessonId(null) : openEdit(row))} style={s.chipEditBtn}>✏️</button>
                <button onClick={() => handleRemove(row)} style={s.chipRemoveBtn}>✕</button>
              </div>
              {editingLessonId === row.id && (
                <div style={{ ...s.linkFormBox, width: '100%' }}>
                  <LessonLinkFields
                    data={editForm}
                    onChange={(field, value) => setEditForm((prev) => ({ ...prev, [field]: value }))}
                    categories={categories}
                  />
                  <div style={s.formButtons}>
                    <button onClick={() => handleSaveEdit(row)} style={s.saveButton}>💾 שמור</button>
                    <button onClick={() => setEditingLessonId(null)} style={s.cancelButton}>✕ בטל</button>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}

      <div style={s.pickerRow}>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{ ...s.input, flex: 2 }}
          placeholder="חפש שיעור לפי כותרת..."
        />
        <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} style={{ ...s.input, flex: 1 }}>
          <option value="">כל הרבנים</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      {/* רשימת התוצאות — שורות לחיצות במקום dropdown, כדי שיהיה ברור מיד מה קיים ומה כבר שויך */}
      <div style={s.resultsList}>
        {files.length === 0 ? (
          <div style={s.noAssignments}>לא נמצאו שיעורים תואמים</div>
        ) : (
          files.map((f) => {
            const isAssigned = assignedMp3Ids.has(f.id);
            return (
              <div key={f.id} style={s.resultRow}>
                <div style={s.resultRowText}>
                  <span style={s.resultRowTitle}>{f.title}</span>
                  {!!f.categoryName && <span style={s.resultRowRabbi}>{f.categoryName}</span>}
                </div>
                {isAssigned ? (
                  <span style={s.alreadyAssignedLabel}>✓ משויך</span>
                ) : (
                  <button onClick={() => handleAdd(f.id)} style={s.addSmallButton}>➕ הוסף</button>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* שיוך שיעור מקישור חיצוני — יוצר שורה חדשה בקטלוג השיעורים הכללי */}
      {!showLinkForm ? (
        <button onClick={() => setShowLinkForm(true)} style={s.linkToggleButton}>🔗 הוספת שיעור מקישור חיצוני</button>
      ) : (
        <div style={s.linkFormBox}>
          <LessonLinkFields
            data={linkForm}
            onChange={(field, value) => setLinkForm((prev) => ({ ...prev, [field]: value }))}
            categories={categories}
          />
          <div style={s.formButtons}>
            <button onClick={handleAddFromLink} style={s.saveButton}>➕ הוסף ושייך</button>
            <button onClick={() => { setShowLinkForm(false); setLinkForm(defaultLinkForm()); }} style={s.cancelButton}>✕ בטל</button>
          </div>
        </div>
      )}
    </div>
  );
};

const SpecialDaysTab = () => {
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showAddForm, setShowAddForm] = useState(false);
  const [newDay, setNewDay] = useState(defaultNewDay());

  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState(null);

  useEffect(() => { loadDays(); }, []);

  const loadDays = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await BOAPI.fetchSpecialDays();
      if (Array.isArray(result)) {
        const [statusObj, data] = result;
        if (statusObj[0]?.code === 0 && Array.isArray(data)) {
          setDays(data);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בטעינת הנתונים');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בטעינת הנתונים');
    } finally {
      setLoading(false);
    }
  };

  const handleAddSubmit = async () => {
    const err = validateDay(newDay);
    if (err) { setError(err); return; }

    try {
      const resp = await BOAPI.addSpecialDay({
        title: newDay.title.trim(),
        hebMonth: newDay.hebMonth,
        hebDay: newDay.hebDay,
        leadDays: newDay.leadDays,
        imageUrl: newDay.imageUrl.trim(),
        aboutText: newDay.aboutText.trim(),
        biographyText: newDay.biographyText.trim(),
      });
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) {
          await loadDays();
          setShowAddForm(false);
          setNewDay(defaultNewDay());
          setError(null);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בהוספה');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בהוספה');
    }
  };

  const handleCancelAdd = () => {
    setShowAddForm(false);
    setNewDay(defaultNewDay());
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setEditData({
      title: item.title || '',
      hebMonth: item.hebMonth,
      hebDay: item.hebDay,
      leadDays: item.leadDays,
      imageUrl: item.imageUrl || '',
      aboutText: item.aboutText || '',
      biographyText: item.biographyText || '',
      isActive: !!item.isActive,
    });
  };

  const handleSaveEdit = async (id) => {
    const err = validateDay(editData);
    if (err) { setError(err); return; }

    try {
      const resp = await BOAPI.updateSpecialDay({
        id,
        title: editData.title.trim(),
        hebMonth: editData.hebMonth,
        hebDay: editData.hebDay,
        leadDays: editData.leadDays,
        imageUrl: editData.imageUrl.trim(),
        aboutText: editData.aboutText.trim(),
        biographyText: editData.biographyText.trim(),
        isActive: editData.isActive,
      });
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) {
          await loadDays();
          setEditingId(null);
          setEditData(null);
          setError(null);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בעדכון');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בעדכון');
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditData(null);
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`למחוק את "${item.title}"? גם השיעורים המשויכים יימחקו.`)) return;
    try {
      const resp = await BOAPI.deleteSpecialDay(item.id);
      if (Array.isArray(resp)) {
        const [statusObj] = resp;
        if (statusObj[0]?.code === 0) {
          await loadDays();
        } else {
          setError(statusObj[0]?.msg || 'שגיאה במחיקה');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה במחיקה');
    }
  };

  const sortedDays = useMemo(() =>
    [...days].sort((a, b) => a.hebMonth - b.hebMonth || a.hebDay - b.hebDay),
    [days]
  );

  if (loading) return <div style={s.center}>טוען...</div>;

  return (
    <div style={s.container}>
      <div style={s.headerSection}>
        <h2 style={s.title}>ימים מיוחדים</h2>
        {!showAddForm && (
          <button onClick={() => setShowAddForm(true)} style={s.addButton}>➕ יום מיוחד חדש</button>
        )}
      </div>
      <p style={s.hint}>
        תאריכים עבריים חוזרים-שנתיים (למשל כ׳ אב) שמוצג בהם אייקון קטן בעמוד הבית, המוביל לעמוד ייעודי
        עם אודות, ביוגרפיה ורשימת שיעורים. אם כמה ימים מיוחדים חלים באותו תאריך — מוצג אייקון אחד לכולם.
      </p>

      {error && (
        <div style={s.error}>
          ❌ {error}
          <button onClick={() => setError(null)} style={s.closeErrorButton}>✕</button>
        </div>
      )}

      {showAddForm && (
        <div style={s.formCard}>
          <h3 style={s.formTitle}>יום מיוחד חדש</h3>
          <SpecialDayFields data={newDay} onChange={(field, value) => setNewDay((prev) => ({ ...prev, [field]: value }))} />
          <div style={s.formButtons}>
            <button onClick={handleAddSubmit} style={s.saveButton}>➕ הוסף</button>
            <button onClick={handleCancelAdd} style={s.cancelButton}>✕ בטל</button>
          </div>
        </div>
      )}

      {sortedDays.length === 0 ? (
        <div style={s.noData}>אין ימים מיוחדים להצגה</div>
      ) : (
        <div style={s.tableWrapper}>
          <table style={s.table}>
            <thead>
              <tr style={s.headerRow}>
                <th style={s.th}>תצוגה</th>
                <th style={s.th}>כותרת</th>
                <th style={s.th}>תאריך עברי</th>
                <th style={s.th}>ימי הקדמה</th>
                <th style={s.th}>סטטוס</th>
                <th style={s.th}>פעולות</th>
              </tr>
            </thead>
            <tbody>
              {sortedDays.map((item) => (
                <React.Fragment key={item.id}>
                  <tr style={s.row}>
                    <td style={s.td}>
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} style={s.thumb} />
                      ) : (
                        <div style={s.thumbEmpty}>—</div>
                      )}
                    </td>
                    <td style={s.td}>{item.title}</td>
                    <td style={s.td}>{item.hebDay}' {monthLabel(item.hebMonth)}</td>
                    <td style={s.td}>{item.leadDays}</td>
                    <td style={s.td}>
                      <span style={{ ...s.statusBadge, backgroundColor: item.isActive ? '#e8f5e9' : '#ffebee', color: item.isActive ? '#2e7d32' : '#c62828' }}>
                        {item.isActive ? '✓ פעיל' : 'לא פעיל'}
                      </span>
                    </td>
                    <td style={s.td}>
                      <div style={s.actionButtons}>
                        <button onClick={() => (editingId === item.id ? handleCancelEdit() : handleEdit(item))} style={s.editButton}>
                          {editingId === item.id ? '✕ בטל' : '✏️ ערוך'}
                        </button>
                        <button onClick={() => handleDelete(item)} style={s.cancelButton}>🗑️ מחק</button>
                      </div>
                    </td>
                  </tr>
                  {editingId === item.id && (
                    <tr>
                      <td style={s.td} colSpan={6}>
                        <div style={s.formCard}>
                          <SpecialDayFields data={editData} onChange={(field, value) => setEditData((prev) => ({ ...prev, [field]: value }))} />
                          <div style={s.formGroup}>
                            <label style={s.checkboxLabel}>
                              <input
                                type="checkbox"
                                checked={editData.isActive}
                                onChange={(e) => setEditData((prev) => ({ ...prev, isActive: e.target.checked }))}
                                style={s.checkbox}
                              />
                              פעיל
                            </label>
                          </div>
                          <LessonsManager specialDayId={item.id} />
                          <div style={s.formButtons}>
                            <button onClick={() => handleSaveEdit(item.id)} style={s.saveButton}>💾 שמור</button>
                            <button onClick={handleCancelEdit} style={s.cancelButton}>✕ בטל</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const s = {
  container: { padding: '20px', direction: 'rtl', fontFamily: 'Arial, sans-serif' },
  headerSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '8px' },
  title: { margin: 0, color: '#1a1f36', fontSize: '24px', fontWeight: 'bold' },
  hint: { color: '#697386', fontSize: '13px', marginBottom: '20px', lineHeight: 1.6 },
  addButton: { padding: '10px 20px', backgroundColor: '#4caf50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  addSmallButton: { padding: '8px 14px', backgroundColor: '#eef7ee', color: '#2e7d32', border: '1px solid #c8e6c9', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', whiteSpace: 'nowrap' },

  formCard: { backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '20px' },
  formTitle: { marginTop: 0, marginBottom: '20px', color: '#333', fontSize: '18px' },
  formGroup: { marginBottom: '15px' },
  formRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '15px' },
  label: { display: 'block', marginBottom: '5px', color: '#333', fontWeight: 'bold', fontSize: '14px' },
  input: { width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', direction: 'rtl', textAlign: 'right', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', direction: 'rtl', boxSizing: 'border-box', resize: 'vertical' },
  checkbox: { marginLeft: '5px', cursor: 'pointer' },
  checkboxLabel: { display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px' },
  formButtons: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '10px' },

  lessonsSection: { marginTop: '10px', paddingTop: '15px', borderTop: '1px dashed #ddd' },
  targetTitle: { fontSize: '13px', color: '#697386', fontWeight: 'bold', marginBottom: '12px' },
  pickerRow: { display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' },
  chipsRow: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  chip: { display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', backgroundColor: '#eef7ee', border: '1px solid #c8e6c9', borderRadius: '16px', fontSize: '13px' },
  chipLabel: { cursor: 'default' },
  chipEditBtn: { background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '12px', padding: 0 },
  chipRemoveBtn: { background: 'transparent', border: 'none', color: '#c62828', cursor: 'pointer', fontSize: '12px', padding: 0 },
  noAssignments: { color: '#bbb', fontSize: '13px' },

  resultsList: { marginTop: '10px', maxHeight: '260px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px' },
  resultRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', padding: '10px 12px', borderBottom: '1px solid #f2f2f2' },
  resultRowText: { display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 },
  resultRowTitle: { fontSize: '13.5px', color: '#333' },
  resultRowRabbi: { fontSize: '12px', color: '#999' },
  alreadyAssignedLabel: { fontSize: '12px', color: '#2e7d32', fontWeight: 'bold', whiteSpace: 'nowrap' },

  linkToggleButton: { marginTop: '14px', padding: '8px 14px', backgroundColor: '#eef2ff', color: '#3949ab', border: '1px solid #c5cae9', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' },
  linkFormBox: { marginTop: '14px', backgroundColor: '#f9f9ff', borderRadius: '8px', border: '1px solid #e0e0f0', padding: '14px' },

  tableWrapper: { overflowX: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' },
  headerRow: { backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' },
  th: { padding: '15px', textAlign: 'right', fontWeight: 'bold', color: '#333', fontSize: '14px', borderBottom: '2px solid #ddd' },
  row: { borderBottom: '1px solid #eee' },
  td: { padding: '15px', color: '#666', fontSize: '14px', textAlign: 'right', verticalAlign: 'middle' },
  thumb: { width: 48, height: 48, borderRadius: 8, objectFit: 'cover' },
  thumbEmpty: { width: 48, height: 48, borderRadius: 8, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb' },

  statusBadge: { display: 'inline-block', padding: '6px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' },
  actionButtons: { display: 'flex', gap: '8px', justifyContent: 'flex-end' },
  editButton: { padding: '8px 16px', backgroundColor: '#1f6feb', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' },
  saveButton: { padding: '8px 14px', backgroundColor: '#2e7d32', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' },
  cancelButton: { padding: '8px 14px', backgroundColor: '#c62828', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' },

  center: { textAlign: 'center', padding: '40px', color: '#999' },
  error: { padding: '15px', backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px', marginBottom: '20px', fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  closeErrorButton: { backgroundColor: 'transparent', color: '#c62828', border: 'none', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' },
  noData: { padding: '40px', textAlign: 'center', color: '#999', backgroundColor: '#f5f5f5', borderRadius: '4px' },
};

export default SpecialDaysTab;
